const NEWS_API_KEY = "4617106e16614174bc976bfa38ac3fed";

const getBitcoinArticles = async () => {
  const response = await fetch(
    `https://newsapi.org/v2/everything?q=crypto&sortBy=publishedAt&apiKey=${NEWS_API_KEY}`
  );
  const json = await response.json();
  return json;
};

export default getBitcoinArticles;
